<template>
  <div>
    <v-container fluid>

      <v-snackbar v-model="alert" centered color="success" timeout="800" top>
        <v-icon dark left>mdi-check-circle</v-icon>
        Copié dans le presse-papier.
      </v-snackbar>

      <div class="main">
        <v-row>
          <v-col cols="12">
            <div class="d-flex justify-space-between mb-3">
              <v-spacer/>

              <v-btn class="rounded-lg"
                     color="gifty"
                     dark
                     @click="$refs.createApiKeyDialog.open()"
                     depressed
              >
                <v-icon left>mdi-plus</v-icon>
                Ajouter une clé API
              </v-btn>
            </div>

            <v-card class="rounded-lg shadow">
              <v-overlay :value="overlay" absolute color="white" opacity="0.5">
                <v-progress-circular
                    color="primary"
                    indeterminate
                    size="50"
                ></v-progress-circular>
              </v-overlay>

              <v-card-title>
                <div>
                  <v-text-field
                      v-model="keyword"
                      append-icon="mdi-magnify"
                      clearable
                      dense
                      filled
                      hide-details
                      placeholder="Rechercher..."
                      rounded
                      single-line

                  />
                </div>
                <v-spacer/>

                <v-btn color="grey"
                       icon
                       @click="getData">
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>

              </v-card-title>

              <v-divider/>

              <v-card-text v-if="isLoading">
                <v-skeleton-loader type="table"/>
              </v-card-text>

              <div v-else>
                <v-card-text class="pa-0">

                  <v-data-table v-if="apiKyes.length"
                                show-expand
                                :headers="headers"
                                :items="apiKyes"
                                :search="keyword"
                  >
                    <template v-slot:item.data-table-expand="{ item, isExpanded, expand }">

                      <v-btn color="gifty"
                             icon
                             depressed
                             @click="expand(true)"
                             v-if="!isExpanded">
                        <v-icon>mdi-plus-circle-outline</v-icon>
                      </v-btn>

                      <v-btn @click="expand(false)"
                             color="gifty"
                             icon
                             depressed
                             v-if="isExpanded"
                      >
                        <v-icon>mdi-minus-circle-outline</v-icon>
                      </v-btn>

                    </template>
                    <template v-slot:item.is_active="{ item }">
                      <v-switch v-model="item.is_active"
                                class="pa-0 ma-0"
                                color="success"
                                hide-details
                                readonly
                                @click="changeStatus(item.id)"></v-switch>

                    </template>

                    <template v-slot:item.api_key="{ item }">
                      <div class="grey lighten-4 pa-1 my-2 rounded text-no-wrap" v-if="item.api_key">
                        {{ item.api_key }}
                        <v-btn color="gifty" icon @click="copy(item.api_key)">
                          <v-icon small>mdi-content-copy</v-icon>
                        </v-btn>
                      </div>
                    </template>

                    <template v-slot:item.access_token="{ item }">
                      <div class="grey lighten-4 pa-1 my-2 rounded text-no-wrap" v-if="item.access_token">
                        {{ item.access_token }}
                        <v-btn color="gifty" icon @click="copy(item.access_token)">
                          <v-icon small>mdi-content-copy</v-icon>
                        </v-btn>
                      </div>
                    </template>


                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length">
                        <v-row justify="center">
                          <v-col cols="8">

                            <div v-if="item.secret_key" class="grey lighten-4 pa-1 my-2 rounded text-no-wrap">
                              Secret key (Signature) : {{ item.secret_key }}
                              <v-btn color="gifty" icon @click="copy(item.secret_key)">
                                <v-icon small>mdi-content-copy</v-icon>
                              </v-btn>
                            </div>

                            <div v-if="item.account_id" class="grey lighten-4 pa-1 my-2 rounded text-no-wrap">
                              Account ID : {{ item.account_id }}
                              <v-btn color="gifty" icon @click="copy(item.account_id)">
                                <v-icon small>mdi-content-copy</v-icon>
                              </v-btn>
                            </div>

                            <div v-if="item.service" class="grey lighten-4 pa-1 my-2 rounded text-no-wrap">
                              Service Name : {{ item.service?.name }} | Service ID : {{ item.service_id }}
                              <v-btn color="gifty" icon @click="copy(item.service_id)">
                                <v-icon small>mdi-content-copy</v-icon>
                              </v-btn>
                            </div>

                            <div v-if="item.store" class="grey lighten-4 pa-1 my-2 rounded text-no-wrap">
                              Store Name : {{ item.store?.name }} | Store ID : {{ item.store_id }}
                              <v-btn color="gifty" icon @click="copy(item.store_id)">
                                <v-icon small>mdi-content-copy</v-icon>
                              </v-btn>
                            </div>

                          </v-col>
                        </v-row>
                      </td>
                    </template>


                    <template v-slot:item.actions="{ item }">
                      <div class="d-flex">
                        <v-btn icon @click="$refs.createApiKeyDialog.open(item)">
                          <v-icon>mdi-pencil-outline</v-icon>
                        </v-btn>
                        <v-btn icon @click="remove(item.id)">
                          <v-icon>mdi-delete-outline</v-icon>
                        </v-btn>
                        <v-btn icon @click="downloadJson(item)">
                          <v-icon>mdi-download</v-icon>
                        </v-btn>
                      </div>
                    </template>


                  </v-data-table>

                  <div v-else>
                    <NoResults @reload="getData"/>
                  </div>

                </v-card-text>

              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <CreateApiKeyDialog ref="createApiKeyDialog" @refresh="getData"/>

    </v-container>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";
import NoResults from "@/components/NoResults";
import CreateApiKeyDialog from "./components/CreateApiKeyDialog.vue";

export default {
  components: {CreateApiKeyDialog, NoResults},
  data() {
    return {
      id: '',
      keyword: '',
      overlay: false,
      isLoading: false,
      alert: false,
      apiKyes: [],
      headers: [
        {
          text: 'Activé',
          align: 'start',
          sortable: false,
          value: 'is_active',
        },
        {
          text: 'Compte',
          value: 'account.user.name',
        },
        {
          text: 'Api key(Client ID)',
          value: 'api_key',
        },
        {
          text: 'Access token',
          value: 'access_token',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
        },
        {text: '', value: 'data-table-expand'},
      ],
    };
  },
  methods: {
    async copy(text) {
      this.alert = false
      try {
        await navigator.clipboard.writeText(text);
        this.alert = true
      } catch ($e) {
        console.log($e)
      }
    },
    getData() {
      this.isLoading = true
      HTTP.get('/v1/api-keys').then(res => {
        this.apiKyes = res.data.data
        this.isLoading = false
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
    remove(id) {
      this.id = id;
      this.$confirm_dialog = true;
    },
    deleteItem() {
      this.overlay = true;
      HTTP.post("/v1/api-keys/delete", {
        id: this.id,
      }).then(() => {
        this.overlay = false;
        let i = this.apiKyes.findIndex((el) => el.id === this.id);
        this.$delete(this.apiKyes, i);
        this.id = null;
        this.$successMessage = "Cet élément a été supprimé avec succès.";
      }).catch((err) => {
        this.overlay = false;
        console.log(err);
      });
    },
    changeStatus(id) {
      this.overlay = true;
      HTTP.post("/v1/api-keys/change-status", {
        id: id,
      }).then(() => {
        this.overlay = false;
        let index = this.apiKyes.findIndex(el => el.id === id)
        this.apiKyes[index].is_active = !this.apiKyes[index].is_active
        this.$successMessage = "Cet élément a été modifié avec succès.";
      }).catch((err) => {
        this.overlay = false;
        console.log(err);
      });
    },
    downloadJson(item) {
      const data = {
        client_id: item.api_key || "",
        access_token: item.access_token || "",
        secret_key: item.secret_key || "",
        account_id: item.account_id || "",
        service_id: item.service_id || "",
        store_id: item.store_id || "",
      };

      const jsonString = JSON.stringify(data, null, 2);

      const blob = new Blob([jsonString], {type: 'application/json'});
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = `${(item.account?.user?.name || 'unknown').replace(/\s+/g, '-').toLowerCase()}-credentials.json`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);
    }
  },
  created() {
    this.getData();
  },
  watch: {
    $is_confirm: function (el) {
      if (el) {
        this.deleteItem();
        this.$is_confirm = false;
      }
    }
  }
};
</script>

<style scoped></style>
